import React from "react";
import modalStyles from "@/styles/Modal.module.scss";
import formStyles from "@/styles/Form.module.scss";
import { Button } from "../Buttons";
import { useCallback, useEffect, useState, useRef, forwardRef } from "react";
import { useForm } from "react-hook-form";
import routes from "@/lib/routes";
import { SelectField, HiddenField } from "../Form/Parts";

const ChatMessageReportStepReport = (props) => {
  const [reason, setReason] = useState("商業目的のコンテンツやスパム");
  const handleReportSend = useCallback(() => {
    props.handleReportSend(props.id, reason);
  }, [props, reason]);
  const onClickHandle = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  const onChangeHandle = useCallback((e) => {
    setReason(e.value);
  }, []);
  return (
    <>
      <header>
        <h3>通報理由</h3>
        <p>通報理由を選択してください。</p>
      </header>
      <div onClick={onClickHandle}>
        <fieldset
          className={`${formStyles.basicFieldset} ${formStyles.marginOff}`}
        >
          <SelectField
            name="reason"
            options={[
              {
                value: "差別的、わいせつ的、暴力的な発言内容",
                label: "差別的、わいせつ的、暴力的な発言内容",
                order: 1,
              },
              {
                value: "嫌がらせ、煽り、過度ないたずら",
                label: "嫌がらせ、煽り、過度ないたずら",
                order: 2,
              },
              {
                value: "脅迫、恐喝、詐欺など違法行為",
                label: "脅迫、恐喝、詐欺など違法行為",
                order: 3,
              },
              {
                value: "個人情報の漏洩や権利の侵害",
                label: "個人情報の漏洩や権利の侵害",
                order: 4,
              },
              {
                value: "スパム行為、荒らしなどの迷惑行為",
                label: "スパム行為、荒らしなどの迷惑行為",
                order: 5,
              },
              {
                value: "商用目的の利用",
                label: "商用目的の利用",
                order: 6,
              },
              {
                value: "その他不適切な内容",
                label: "その他不適切な内容",
                order: 7,
              },
            ]}
            readOnly
            required
            placeholder="通報理由を選択"
            defaultValue={{
              value: "差別的、わいせつ的、暴力的な発言内容",
              label: "差別的、わいせつ的、暴力的な発言内容",
            }}
            onChange={onChangeHandle}
            customStyles={{
              control: (provided) => ({
                ...provided,
                color: "#FFF",
                backgroundColor: "#101112",
                border: "#101112",
              }),
              menuList: (provided) => ({
                ...provided,
                color: "#FFF",
                backgroundColor: "#101112",
                fontSize: "14px",
              }),
              option: (provided) => ({
                ...provided,
                padding: "4px 16px",
                color: "#FFF",
                backgroundColor: "#101112",
                fontSize: "14px",
              }),
              singleValue: (provided) => ({
                ...provided,
                color: "#FFF",
                marginLeft: "0",
                marginRight: "0",
                fontSize: "14px",
                backgroundColor: "#101112",
              }),
            }}
          />
        </fieldset>
      </div>
      <Button
        key="reportSendButton"
        fontFixed
        large
        fillWhiteColor
        onClick={handleReportSend}
      >
        通報する
      </Button>
      <Button fontFixed large borderLight onClick={props.modalCloseHandle}>
        閉じる
      </Button>
    </>
  );
};

export default ChatMessageReportStepReport;
